import React from "react";
import { Box, Text, useMediaQuery, Flex, Badge } from "@chakra-ui/react";
import { CheckIcon } from '@chakra-ui/icons'
import { DynoIcon } from "../../components/DynoIcon";
import "./CreateNewDyno.scss";
import "../../App.scss";

const SelectDynoType = ({ dynoTypes, selectDynoType, selectedDynoType, isPro }) => {
  const [iPadPortrait] = useMediaQuery("(max-width: 1024px)");
  const description = {
    Reading: "Create explanatory lessons with text, images, and examples — ideal for notes, overviews, and concept walkthroughs.",
    Practice: "Build assessments and quizzes to test knowledge and understanding",
    Video: "Create engaging educational videos to visually explain concepts, demonstrate processes, or deliver lessons with audio-visual impact."
  }
  return (
    <Box
      display={iPadPortrait ? "block" : "flex"}
      justify="center"
      spacing={4}
    >
      {dynoTypes
        .filter(({ name }) => name !== "Writing Submission")
        .map((dynoType) => {
          const isSelected = dynoType.name === selectedDynoType.name;
          const isVideoPro = dynoType.name === "Video" && !isPro;

          return (
            <Box
              key={dynoType.id}
              w="100%"
              p={6}
              mt={3}
              mr={3}
              cursor="pointer"
              position="relative"
              borderWidth="2px"
              borderRadius="lg"
              borderColor={isSelected ? "blue.500" : "gray.200"}
              bg={isSelected ? "blue.50" : "white"}
              _hover={{ borderColor: "blue.500", background: "blue.50" }}
              onClick={() => selectDynoType(dynoType)}
            >
              <Flex alignItems="center" position="absolute" top="2" right="2">
                <Box color="blue.500" mr={2} visibility={isSelected ? "visible" : "hidden"}>
                  <CheckIcon boxSize={5} />
                </Box>
                {isVideoPro && (
                  <Badge variant="solid" colorScheme="blue">
                    Pro
                  </Badge>
                )}
              </Flex>

              <Flex direction="column" align="center" textAlign="center">
                <Box mr={2}>
                  <DynoIcon dynoType={dynoType.name} />
                </Box>
                <Text fontWeight="bold" fontSize="lg">
                  {dynoType.name}
                </Text>
                <Text fontSize="sm" mt={2} color="gray.600">
                  {description[dynoType.name]}
                </Text>
              </Flex>
            </Box>
          );
        })}
    </Box>
  );
};

export default SelectDynoType;
